import { CellType } from "../config/CellType";
import { CellValidator, CellValidationConfig, CellValidationResult } from "./CellValidation";
import { DEFAULT_CELL_TYPE_VALIDATORS } from "./defaultCellTypeValidators";

export function resolveValidators(
    cellType: CellType,
    validation?: CellValidationConfig,
): CellValidator[] {
    const defaults = DEFAULT_CELL_TYPE_VALIDATORS[cellType] ?? [];
    if (!validation) return defaults;

    const columnValidators = validation.validators ?? [];
    if (validation.overrideDefaults) return columnValidators;

    return [...defaults, ...columnValidators];
}

export function runValidators(
    validators: CellValidator[],
    value: string,
): CellValidationResult {
    for (const validator of validators) {
        const result = validator(value);
        if (!result.valid) return result;
    }
    return { valid: true };
}
